import React from 'react';
import { CustomSticky } from '../ui/sticky/CustomSticky';
import { FormButton } from '../ui/buttons/FormButton';
import FooterButtonContainer from '../ticketForm/components/FooterButtonContainer';
import { Half } from '../ticketForm/components/Half';
import LogItem from '../log/LogItem';
import usePriceNegotiationPermissions from 'modules/emergencies/permissions/usePriceNegotiationPermissions';
import PRICE_NEGOTIATION_PERMISSIONS_NAMES from 'modules/emergencies/permissions/priceNegotiationPermissionsNames';

const NewQuoteFormFooter = ({ quoteFormFooterData }) => {
  const {
    backendErrors,
    setShowErrors,
    isWaitingForResponse,
    submitFormikForm,
    //  onCancel
  } = quoteFormFooterData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;
  return (
    <>
      {/* <FormButton variant="ghost" onClick={onCancel}>
        Back
      </FormButton> */}
      <Half></Half>
      <Half>
        <FormButton
          isDisabled={isWaitingForResponse}
          onClick={() => {
            setShowErrors(true);
            submitFormikForm();
          }}
        >
          Save and send quote {hasBackendErrors && <> ⚠️ </>}
        </FormButton>
      </Half>
    </>
  );
};

const QuoteDetailEditFormFooter = ({ quoteFormFooterData }) => {
  const {
    backendErrors,
    setShowErrors,
    isWaitingForResponse,
    submitFormikForm,
    // onCancel,
    onRejectQuote,
    onAcceptQuote,
    dirty,
    isStateEdit,
  } = quoteFormFooterData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;

  const canRejectQuote = usePriceNegotiationPermissions(
    PRICE_NEGOTIATION_PERMISSIONS_NAMES.QUOTE_REJECTION
  );
  const canAcceptQuote = usePriceNegotiationPermissions(
    PRICE_NEGOTIATION_PERMISSIONS_NAMES.QUOTE_ACCEPTANCE
  );
  const canEditQuote = usePriceNegotiationPermissions(
    PRICE_NEGOTIATION_PERMISSIONS_NAMES.QUOTE_EDITION
  );

  return (
    <>
      {!!onRejectQuote && isStateEdit && (
        <FormButton variant="ghost" onClick={onRejectQuote} isDisabled={!canRejectQuote}>
          Reject quote
        </FormButton>
      )}
      {!!onAcceptQuote && isStateEdit && (
        <FormButton variant="ghost" onClick={onAcceptQuote} isDisabled={!canAcceptQuote}>
          Accept quote
        </FormButton>
      )}
      <FormButton
        isDisabled={!canEditQuote || isWaitingForResponse || !dirty}
        onClick={() => {
          setShowErrors(true);
          submitFormikForm();
        }}
      >
        Save changes {hasBackendErrors && <> ⚠️ </>}
      </FormButton>
    </>
  );
};

export const QuoteFormFooter = ({ quoteFormFooterData }) => {
  const { isEdit, isReadOnly, quoteDetail } = quoteFormFooterData;
  const showLog = isEdit || isReadOnly;
  const showFooterButtons = (!isEdit && !isReadOnly) || isEdit;
  return (
    <CustomSticky flexColumn={showLog}>
      {showLog && <LogItem log={quoteDetail?.logs[0]} separatorProps={{ fullWidth: true }} />}
      <FooterButtonContainer withTopComponent={showLog && showFooterButtons}>
        {!isEdit && !isReadOnly && <NewQuoteFormFooter quoteFormFooterData={quoteFormFooterData} />}
        {isEdit && <QuoteDetailEditFormFooter quoteFormFooterData={quoteFormFooterData} />}
      </FooterButtonContainer>
    </CustomSticky>
  );
};
